import { Image, Text, View } from '@react-pdf/renderer';

import { Header } from '../components/Header.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { orderDetailFields, propertyDetailFields } from '../constants.ts';
import { fontStyles, propertyOrderDetailsPageStyles as styles } from '../styles.ts';
import { PropertyOrderProps } from '../types.ts';

export const PropertyOrderDetailsPage = ({
  subjectAddress,
  shortPropertyType,
  appraisalType,
  effectiveDate,
  inspectionDate,
  clientName,
  clientAddress,
  borrowerName,
  zoning,
  zoningCompliance,
  parcelNumber,
  propertyInterest,
  hoa,
  hoaFees,
  legalDescription,
  orderNumber,
  intendedUsers,
  intendedUse,
  propertyMapImage,
}: PropertyOrderProps) => (
  <Tkv2PDFPage title="Subject Property Details" address={subjectAddress}>
    <View style={styles.section}>
      {propertyMapImage && <Image src={propertyMapImage} style={styles.propertyImage} />}
      <View style={styles.details}>
        {propertyDetailFields(
          subjectAddress,
          shortPropertyType,
          zoning,
          zoningCompliance,
          parcelNumber,
          propertyInterest,
          hoa,
          hoaFees,
          legalDescription,
        ).map(({ key, label, getValue }) => {
          const value = getValue();
          if (!value) return null;
          return (
            <View style={styles.detail} key={key}>
              <View style={styles.label}>
                <Text style={fontStyles.bodyLight}>{label}</Text>
              </View>
              <View style={styles.value}>
                <Text style={fontStyles.h4}>{value}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </View>

    <Header title="Order Details" address={subjectAddress} showAddress={false} />

    <View style={styles.section}>
      <View style={styles.details}>
        {orderDetailFields(
          clientName,
          clientAddress,
          borrowerName,
          appraisalType,
          orderNumber,
          inspectionDate,
          effectiveDate,
          intendedUsers,
          intendedUse,
        ).map(({ key, label, getValue }) => {
          const value = getValue();
          if (!value) return null;
          return (
            <View style={styles.detail} key={key}>
              <View style={styles.label}>
                <Text style={fontStyles.bodyLight}>{label}</Text>
              </View>
              <View style={styles.value}>
                <Text style={fontStyles.h4}>{value}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  </Tkv2PDFPage>
);
